module.exports = __webpack_public_path__ + "img/xgqc.d0c67a6a.png";